import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { PromoDetailsComponent } from '../../../shared-extra/components/promo-details/promo-details.component';
import { ContextMenuComponent } from '../../../shared/components/context-menu/context-menu.component';
import { SvgComponent } from '../../../shared/components/svg/svg.component';
import { ButtonDirective } from '../../../shared/directives/button.directive';
import { Promotion } from '../../../types/promotion.type';

@Component({
  selector: 'app-checkout-coupon',
  changeDetection: ChangeDetectionStrategy.OnPush,
  templateUrl: './checkout-coupon.component.html',
  styleUrl: './checkout-coupon.component.scss',
  imports: [SvgComponent, ContextMenuComponent, ButtonDirective, PromoDetailsComponent],
})
export class CheckoutCouponComponent {
  promotion = input.required<Promotion>();
}
